__turbopack_context__.v({
  "event": "mM8I4G_event",
  "event_content": "mM8I4G_event_content",
  "event_date": "mM8I4G_event_date",
  "event_day": "mM8I4G_event_day",
  "event_details": "mM8I4G_event_details",
  "event_info": "mM8I4G_event_info",
  "event_link_icon": "mM8I4G_event_link_icon",
  "event_location": "mM8I4G_event_location",
  "event_month": "mM8I4G_event_month",
  "event_name": "mM8I4G_event_name",
  "event_pre": "mM8I4G_event_pre",
  "event_with_link": "mM8I4G_event_with_link",
  "event_without_link": "mM8I4G_event_without_link",
});
